import { ProductSearchViewModel } from '@models/api-search.models';

import { generatePromotion } from '@utils/gtm-tracking/utils/generatePromotion';
import { PromotionViewEventBase } from '@utils/gtm-tracking/model/Promotion';

export type PromotionViewEvent = Omit<PromotionViewEventBase, 'event'> &  {
    event: 'view_promotion';
};

export type PromotionSettings = Pick<PromotionViewEvent, 'creative_name' | 'creative_slot' | 'promotion_id' | 'promotion_name'> & {
    index: number;
}
export type PromotionCreativeName = 'USP Spot - PLP' | 'USP Spot - Unknown';

/**
 * Track promotion view event with promotion settings and product in case of product promotion
 * @param promoSetting the promotion settings
 * @param product the product to track
 */
export const trackPromotionViewEvent = (promoSetting: PromotionSettings, product?: ProductSearchViewModel): PromotionViewEvent => ({
    event: 'view_promotion',
    ...generatePromotion(promoSetting, product)
});
